import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import VehicleTitle from '../components/VehicleTitle';
import VehicleCardData from '../components/VehicleCardData';
import HighlightedAttributeContainer from '../components/HighlightedAttributeContainer';

const DetailsContainer = ({
	vehicle,
	incentives,
	accounts,
	isTabbedLayout,
	isGridLayout
}) => {
	const { accountId } = useSelector(state => state.widgetInfo);

	return (
		<div className="vehicle-card-details-container">
			<VehicleTitle
				isTabbedLayout={isTabbedLayout}
				title={vehicle.title}
				link={vehicle.link}
				vehicleId={vehicle.uuid}
				condition={vehicle.condition}
			/>
			<HighlightedAttributeContainer
				isTabbedLayout={isTabbedLayout}
				accountInfo={{
					...accounts[vehicle.accountId],
					id: vehicle.accountId,
					fuelType: vehicle.fuelType
				}}
			/>
			<VehicleCardData
				attributes={vehicle.attributes}
				callouts={vehicle.callout}
				isTabbedLayout={isTabbedLayout}
				isGridLayout={isGridLayout}
				uuid={vehicle.uuid}
				pricing={vehicle.pricing}
				incentives={incentives}
				condition={vehicle.condition}
				accountInfo={{
					...accounts[vehicle.accountId],
					id: vehicle.accountId
				}}
				accountId={accountId}
				vehicleAccountId={vehicle.accountId}
				incentiveIds={
					vehicle.incentiveIds || vehicle.bestIncentiveIds || []
				}
				inventoryButtons={vehicle.inventoryButtons}
				packages={vehicle.packages}
				link={vehicle.link}
			/>
		</div>
	);
};

DetailsContainer.propTypes = {
	vehicle: PropTypes.shape({
		title: PropTypes.arrayOf(PropTypes.string),
		uuid: PropTypes.string,
		link: PropTypes.string,
		accountId: PropTypes.string,
		condition: PropTypes.string,
		callout: PropTypes.arrayOf(PropTypes.object),
		packages: PropTypes.arrayOf(PropTypes.string),
		incentiveIds: PropTypes.arrayOf(PropTypes.string),
		bestIncentiveIds: PropTypes.arrayOf(PropTypes.string),
		inventoryButtons: PropTypes.arrayOf(PropTypes.object),
		images: PropTypes.arrayOf(PropTypes.object),
		attributes: PropTypes.arrayOf(PropTypes.object),
		pricing: PropTypes.shape({}),
		year: PropTypes.number,
		model: PropTypes.string,
		trim: PropTypes.string,
		make: PropTypes.string,
		vin: PropTypes.string,
		fuelType: PropTypes.string
	}).isRequired,
	incentives: PropTypes.shape({}),
	accounts: PropTypes.shape({}),
	isTabbedLayout: PropTypes.bool.isRequired,
	isGridLayout: PropTypes.bool
};

DetailsContainer.defaultProps = {
	incentives: {},
	accounts: {}
};

export default DetailsContainer;
